import { Box, Button, Card, CardHeader, FormControlLabel, FormGroup, IconButton, Switch, Tooltip, Grid, Avatar, Typography, InputAdornment, TextField, Dialog, DialogTitle, DialogActions, CardContent } from "@mui/material";
import { IMAGE_BASE, STATUS_OPTIONS_LIST } from "../../utils/constants";
import TableFilter from "../../components/shared/TableFilter";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams } from "react-router-dom";
import { apiCategory } from "../../services/AllServices";
import { Loader } from "../../components/CustomLoader";
import errorHandler from "../../utils/errorHandler";
import DeleteIcon from "@mui/icons-material/Delete";
import { EditOutlined } from "@mui/icons-material";
import DataTable from "react-data-table-component";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { fDate } from "../../utils/formatTime";
import { capitalize } from "../../utils/helpers";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const ViewSubCategory = () => {

  const navigate = useNavigate();
  const [searchItem, setSearchItem] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [data, setData] = useState();
  const [warning, setWarning] = useState("");
  const [action, setAction] = useState("");
  const [show, setShow] = useState(false);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [statusId, setStatusId] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [status, setStatus] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loaderDelay, setLoaderDelay] = useState(false);
  const [dataCategory, setDataCategory] = useState({});
  const { id } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiCategory.getById({ id: id });
        setDataCategory(response?.data?.data);
      } catch (error) {
        errorHandler(error);
      }
    };

    fetchData();
  }, [id]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleClose = () => setShow(false);

  const columns = [
    {
      name: "S.No.",
      sortable: false,
      cell: (row, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      name: "Sub Category",
      sortable: true,
      selector: (row) => capitalize(row.name),
    },
    {
      name: "Created At",
      sortable: true,
      selector: (row) => capitalize(fDate(row.createdAt)),
    },
    {
      name: "Status",
      cell: (row) => (
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                checked={row.status === "active"}
                onClick={() => {
                  setShow(true);
                  setCurrentStatus(row.status);
                  setStatusId(row._id);
                  setAction("status");
                  setWarning(
                    `Are you sure you want to ${row.status === "active" ? "inactive" : "activate"
                    } the Sub Category?`
                  );
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
            }
          />
        </FormGroup>
      ),
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <Tooltip title="View" placement="left">
            <IconButton
              color="primary"
              onClick={() => {
                navigate(`/category/viewsubcategory/${row?._id}`);
              }}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Edit" placement="top">
            <IconButton
              color="primary"
              onClick={() => {
                navigate(`/category/edit-subcategory/${row?._id}`);
              }}
            >
              <EditOutlined />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete" placement="top">
            <IconButton color="primary" onClick={() => deleteData(row?._id)}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  const deleteData = async (Categoryid) => {
    Swal.fire({
      text: "Are you sure you want to delete this Sub Category?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#00a1da",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await apiCategory.delete({ id: Categoryid });
          if (res?.status === 200) {
            toast.success(res?.data?.message, { toastId: "success" });
            setData((prevData) => prevData.filter((item) => item._id !== Categoryid));
            setTotalPages((prevTotal) => prevTotal - 1);
            setRefresh(!refresh);
          } else {
            toast.error(res?.data?.message, { toastId: "error" });
          }
        } catch (error) {
          console.error("Error deleting...", error);
          errorHandler(error);
        }
      }
    });
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setDebouncedSearch(searchItem);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchItem]);

  useEffect(() => {
    const body = {
      searchItem: debouncedSearch,
      pageNumber: currentPage,
      pageSize: pageSize,
      status: status,
      categoryId: id,
    };
    setIsLoading(true);
    setLoaderDelay(false);

    apiCategory?.getAll(body)?.then((res) => {
      if (res.status === 200) {
        setTimeout(() => {
          setData(res?.data?.data?.data);
          setTotalPages(res?.data?.data?.totalItems);
          setLoaderDelay(true);
        }, 500);
      }
    })
      .catch((err) => {
        setIsLoading(false);
        errorHandler(err);
        setLoaderDelay(false);
      })
      .finally(() => {
        setIsLoading(false);
        setLoaderDelay(false);
      });
  }, [debouncedSearch, currentPage, pageSize, refresh, status]);

  const toggleChecked = async (id, currentStatus) => {
    try {
      const newStatus = currentStatus === "active" ? "inactive" : "active";

      const res = await apiCategory.changeStatus({
        id,
        status: newStatus,
      });

      setCurrentStatus("");

      if (res.status === 200 && res?.data?.message) {
        toast.success(res?.data?.message, { toastId: "success1" });
        setRefresh(!refresh);
        setShow(false);
      } else {
        toast.error(res?.data?.message, { toastId: "error1" });
        setShow(false);
      }
    } catch (err) {
      setShow(false);
      errorHandler(err);
    }
  };

  return (
    <Card>
      <CardHeader
        titleTypographyProps={{ variant: "h4" }}
        title="Sub Category"
        action={
          <IconButton onClick={() => navigate(-1)} color="primary">
            <ArrowBackIcon />
          </IconButton>
        }
      />
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={4}>
          <Box display="flex" flexDirection="column" alignItems="center" p={2}>
            <Avatar
              src={IMAGE_BASE + dataCategory?.image}
              alt="Category"
              sx={{ width: 150, height: 150, mb: 2 }}
            />
            <Typography variant="h6">Sub Category Name</Typography>
            <Typography variant="body1" sx={{ overflowWrap: "break-word" }}>
              {dataCategory?.name || ""}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={8}>
          <CardContent>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <TextField
                label="Search"
                variant="outlined"
                size="small"
                className="subcategorySearchox"
                value={searchItem}
                onChange={(e) => setSearchItem(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {searchItem && (
                        <IconButton onClick={() => setSearchItem("")}>
                          <CloseIcon />
                        </IconButton>
                      )}
                    </InputAdornment>
                  ),
                }}
                sx={{ width: 200, marginRight: 1 }}
              />
              <TableFilter
                data={STATUS_OPTIONS_LIST}
                value={status}
                setValue={setStatus}
                filterName="Status"
              />
              <Button
                variant="contained"
                color="primary"
                onClick={() => navigate(`/category/add-subcategory/${id}`)}
              >
                Add Sub Category
              </Button>
            </Box>
          </CardContent>

          <CardContent>
            <Box>
              <DataTable
                customStyles={{
                  headCells: {
                    style: {
                      fontSize: "15px",
                      fontWeight: "bold",
                    },
                  },
                }}
                columns={columns}
                data={data}
                pagination
                paginationServer
                paginationTotalRows={totalPages}
                onChangePage={handlePageChange}
                paginationPerPage={pageSize}
                paginationRowsPerPageOptions={[10, 20, 50]}
                onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                  setPageSize(currentRowsPerPage);
                  setCurrentPage(currentPage);
                }}
                progressPending={isLoading || !loaderDelay}
                progressComponent={<Loader />}
                className="custom"
              />
            </Box>
          </CardContent>
        </Grid>
      </Grid>

      <Dialog open={show} keepMounted onClose={handleClose} aria-describedby="alert-dialog-slide-description" className="popupbox-statis">
        <DialogTitle as="h3">{warning}</DialogTitle>
        <DialogActions className="status-box-action">
          <Button
            variant="outlined"
            onClick={() => {
              if (action === "status") {
                toggleChecked(statusId, currentStatus);
              }
            }}
          >
            Yes
          </Button>
          <Button
            variant="outlined"
            onClick={handleClose}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default ViewSubCategory;